export default "__VITE_ASSET__BUkdQ3Sq__"